<div>
  <ems-toast-message *ngIf="(!(sharedService.errorMessage | async) || showToast)" #toastMessage></ems-toast-message>
  <ems-confirm-message #instrumentGrpDeleteConfirmMsg></ems-confirm-message>

  <sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none"
    *ngIf="schError.minCharacter === true || schError.invalidCharacter === true">
    <div class="sdps-notification__text" id="sdpsErrorNotificationTest">
      <p [innerText]="sharedConst.pleaseCorrectFollowingError"></p>
      <ul class="sdps-navigation--horizontal__list error-list">
        <li *ngIf="schError.minCharacter" [innerHTML]="sharedConst.textFieldErrorMsg.minCharLimitErrorMsg"></li>
        <li *ngIf="schError.invalidCharacter"
          [innerHTML]="sharedConst.textFieldErrorMsg.invalidCharacterForGrpOrRuleName"></li>
      </ul>
    </div>
  </sdps-notification>

  <h2 class="page-title sdps-m-bottom_large sdps-display-inline-block"
    [innerHTML]="getEmtrConstants.instrumentGroups.instrumentGroupsText"></h2>
  <span class="sdps-m-horizontal_large sdps-display-inline-block client-selection-indicator" [innerHTML]="k4ClientName">
  </span>
</div>

<ems-view-history #viewHistory [historyId]="instGrpHistoryRecord.historyId" [getOrgId]="getOrgId"
  [ruleSubType]="instGrpHistoryRecord.instGrpSecurities" [historyTitle]="instGrpHistoryRecord.instGrpName"
  [historyData]="instGrpHistoryRecord.instGrpHistory" [totalElements]="instGrpHistoryRecord.historyRecords"
  (paginateHistoryList)="getHistoryPagination(instGrpHistoryRecord.historyId, $event)"></ems-view-history>

<div class="tbl-rec-count">
  <button id="addNewInstrumentGroupButton" type="button" class="buttons button-save sdps-pull-left sdps-m-top_small sdps-m-left_small"
    *ngIf="showActionItems" [routerLink]="getEmtrConstants.instrumentGroups.instrumentGroupList.toStep1"
    (click)="navigateToCreateInstrumentGroup()">
    <em class="pi pi-plus" aria-hidden="true"></em>
    {{getEmtrConstants.instrumentGroups.instrumentGroupList.addNewInstrumentGroup}}
  </button>

  <ems-table-record-count class="tbl-rec-count"
    [showRecords]="paginationCount && paginationCount > sharedConstant.defaultTableRecords" [count]="totalGroups"
    [showTotalForInstrumentGrps]="totalGroups"
    (emitter)="pageObject.pageNo = 0;pageObject.pageSize = $event;applyFilter()" [groupTotal]="totalGroups"
    [showHeaderIcons]="true"></ems-table-record-count>

  <form [formGroup]="instrumentGroupForm">
    <p-table [columns]="groupHeader" [value]="instrumentGrps" [customSort]="true" dataKey="id" sortMode="multiple"
      #empGrps metaKeySelection="true" [lazy]="true" (onLazyLoad)="customSort($event)" [multiSortMeta]="multiSortMeta"
      class="common-data-table">
      <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
        <span class="pi" [ngClass]="{
                    'pi-sort': sortOrder === 0,
                    'pi-caret-down': sortOrder === -1,
                    'pi-caret-up': sortOrder === 1,
                  }"></span>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr class="filter-header-input">
          <th class="table-checkbox-selection filter-icon" aria-label="Filter toggle">
            <span class="sr-only">Filter toggle</span>
            <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
              <em class="pi pi-filter" aria-hidden="true"></em>
            </button>
          </th>
          <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="(col.field==='action')" id="{{col.field}}_labels"
            [ngClass]="[(paginationCount && paginationCount > 1 || filterClicked) ? 'pointer-events-auto' : 'pointer-events-none',  col.header === 'Last Updated' ? 'w-18-per': '',  col.header === 'Name' || col.header === 'Description' ? 'w-20-per': '']"
            [attr.aria-label]="col.header || 'Column'">
            {{col.header || 'Column'}}
            <p-sortIcon [field]="col.field" id="{{col.field}}_sortIcon"
              *ngIf="(col.field!=='action') && (paginationCount && paginationCount > 1 || filterClicked)"></p-sortIcon>
          </th>
        </tr>

        <tr *ngIf="toggle" class="filtered-row-input">
          <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
          <th *ngIf="showSelection" aria-label="Selection"><span class="sr-only">Selection</span></th>
          <th class="sdps-p-left_small" *ngFor="let col of columns ;let i = index;" [attr.aria-label]="(col.header || 'Column') + ' filter'">
            <label class="sr-only" for="filterInput_Name" *ngIf="col.field === 'name'">{{(col.header || 'Name') + ' filter'}}</label>
            <input pInputText [attr.aria-label]="(col.header || 'Name') + ' filter'" formControlName="name" class="w-100-per" type="text" name="name" [maxLength]="30"
              *ngIf="col.field === 'name'" emsStartSpaceValidator emsAlphaNumericSpecialCharacterValidation
              (keydown.enter)="!( instrumentGroupForm.invalid || filterBtnDisableForName) ? applyFilter(): ''"
              onkeydown="return (event.keyCode !== 13);" id="filterInput_Name"
              [ngClass]="{'invalidField': (filterBtnDisableForName || (instrumentGroupForm.get('name').value && instrumentGroupForm.get('name').invalid))}">

            <label class="sr-only" for="filterInput_Description" *ngIf="col.field === 'description'">{{(col.header || 'Description') + ' filter'}}</label>
            <input pInputText [attr.aria-label]="(col.header || 'Description') + ' filter'" formControlName="description" class="w-100-per" type="text" name="description"
             emsStartSpaceValidator (keydown.enter)="!( instrumentGroupForm.invalid || filterBtnDisableForName)? applyFilter(): ''"
              onkeydown="return (event.keyCode !== 13);" *ngIf="col.field === 'description'" [maxLength]="30" id="filterInput_Description"
              [ngClass]="{'invalidField': instrumentGroupForm.get('description').invalid}">

            <div class="timePickerForm" *ngIf="col.enum === 'dropdown'">
              <label class="sr-only" for="filterInput_businessUnit">{{(col.header || 'Business Unit') + ' filter'}}</label>
              <p-select inputId="filterInput_businessUnit" [attr.aria-label]="(col.header || 'Business Unit') + ' filter'" placeholder="" formControlName="businessUnit" [options]="businessUnitData"
                class="editableTimepicker request-list-header-dropdown" optionLabel="name">
              </p-select>
            </div>

            <div *ngIf="col.field === 'updTs'">
              <ems-date-range-filter #range (submittedDate)="getSelectedDate($event);"></ems-date-range-filter>
            </div>
            <div *ngIf="col.field === 'action'" class="w-200-px">
              <button id="clearAllButton" class="buttons button-filter" [disabled]="!instrumentGroupForm.dirty && !isSortingChanged"
                [innerHTML]="sharedConst.filterButton.clearAllButton"
                (click)="isClickedClearBtn = true; filterClicked? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged)"></button>
              <button id="applyFilterButton" class="buttons button-save button-filter" (click)="applyFilter()"
                [disabled]="filterBtnDisableForName || instrumentGroupForm.invalid"
                [innerHTML]="sharedConst.filterButton.applyFilterButton"></button>
            </div>
          </th>
        </tr>

        <tr *ngIf="toggle && showActionItems" class="filter-header-input">
          <th aria-label="Sub-header row"><span class="sr-only">Sub-header row</span></th>
          <th *ngFor="let col of groupSubHeader" [attr.aria-label]="col.header || 'Column'">
            {{col.header || 'Column'}}
          </th>
        </tr>

        <tr *ngIf="toggle && showActionItems" class="filtered-row-input sdps-p-bottom_small">
          <th aria-label="Sub-header filters"><span class="sr-only">Sub-header filters</span></th>
          <th class="sdps-p-left_small sdps-p-bottom_medium igfiltersec" *ngFor="let col of groupSubHeader" [attr.aria-label]="(col.header || 'Column') + ' filter'">
            <div class="timePickerForm" *ngIf="col.enum === 'dropdown'">
              <label class="sr-only" for="filterInput_ShowRecords">Records per page</label>
              <p-select inputId="filterInput_ShowRecords" aria-label="Records per page" placeholder="" formControlName="showRecords"
                [options]="getEmtrConstants.showRecords" class="editableTimepicker request-list-header-dropdown"
                optionLabel="label">
              </p-select>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1" class="sdps-text-center sdps-font-weight-bold"
            [innerHTML]="getEmtrConstants.rulesConstant.autoComplete.noRecords"></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td class="table-checkbox-selection filter-icon"></td>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field !== 'action'" class="sdps-truncate--ellipses">
              <button type="button" [title]="rowData[col.field]" *ngIf="col.field === 'name'" (click)="editInstrumentGroup(rowData)"
                class="btn-text-link ruleGrpLinks" [attr.aria-label]="'Edit instrument group ' + rowData[col.field]">{{ rowData[col.field]}}</button>
              <span [title]="rowData[col.field]" *ngIf="col.field !== 'name' && col.field !== 'updTs'"
                [innerHTML]='rowData[col.field]'></span>
              <span [title]="rowData[col.field]" *ngIf="col.field ==='updTs'"
                [innerHTML]="(rowData[col.field]) ? moment(rowData[col.field]).format('MM/DD/YYYY') : ''"></span>
            </td>
          </ng-container>
          <td>
            <div class="sdps-flexbox sdps-flexbox--centered-items">
              <div class="action-menu-dropdown">
                <button type="button" class="cursor sdps-p-around_xx-small"
                  [attr.aria-label]="'Actions for ' + rowData['name']"
                  aria-haspopup="menu"
                  [attr.aria-expanded]="groupId===rowData['id']"
                  (click)="showActionMenu=true; groupId=rowData['id']; formData(rowData);"
                  (keydown)="onActionButtonKeydown($event, rowData)"
                  [ngClass]="{'active-menu':(groupId===rowData['id'])}">
                  <em class="pi pi-ellipsis-h sdps-p-around_xx-small" aria-hidden="true"></em>
                </button>
                <p-menu [model]="actionMenu" *ngIf="groupId===rowData['id']" class="menu-dropdown"></p-menu>
              </div>
            <div>
              @if(rowData['ngOMSsStatus'] && !deletedIGList){
              @if(rowData['consolidateNgOmsLastSyncStatus'] && rowData['consolidateNgOmsLastSyncStatus'].toUpperCase() === 'SUCCESS'){
              <div>
                
                <i [title]="sharedConstant.ngOMS.synStatus + ' - '+ rowData['consolidateNgOmsLastSyncStatus'].toUpperCase()" 
                  class="pi pi-check sdps-text-trade-buy" id="ngOmsSuccessSync"></i>
              </div>
              }
              @else {
              <div> <i
                  [title]=" rowData['consolidateNgOmsLastSyncStatus'].toUpperCase() ? sharedConstant.ngOMS.synStatus +' - '+ rowData['consolidateNgOmsLastSyncStatus'].toUpperCase() : sharedConstant.ngOMS.synStatus + sharedConstant.ngOMS.empty"
                  class="pi pi-times sdps-text-trade-sell" id="ngOmsFailedSync"></i>
              </div>
              }
            }
            </div>
            </div>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </form>

  <p-paginator class="common-pagination" [rows]="pageObject.pageSize"
    [alwaysShow]="paginationCount && paginationCount > sharedConstant.defaultTableRecords ? true : false"
    [totalRecords]="paginationCount" (onPageChange)="paginate($event)" #p>
  </p-paginator>
</div>
